import { apiAuth, apiResponseType } from ".";

/**
 * Busca dados paginados das configurações de comissionamento
 *
 * @function getCommissionConfigData
 * @param {number} page - Número da página a ser buscada
 * @returns {apiResponseType} Resposta da API com dados paginados
 */
export const getCommissionConfigData = (page: number = 1): apiResponseType =>
  apiAuth.get(`commissions/config?page=${page}`);

/**
 * Registra uma nova configuração de comissionamento
 *
 * @function registerCommissionConfigData
 * @param {object} data - Dados do formulário a serem enviados
 * @returns {apiResponseType} Resposta da API com o item criado
 */
export const registerCommissionConfigData = (data: any) =>
  apiAuth.post("commissions/config/store", data) as apiResponseType;

/**
 * Remove uma configuração de comissionamento pelo ID
 *
 * @function deleteCommissionConfigData
 * @param {string} id - ID do item a ser removido
 * @returns {apiResponseType} Resposta da API confirmando a remoção
 */
export const deleteCommissionConfigData = (id: string) =>
  apiAuth.delete(`commissions/config/${id}/destroy`) as apiResponseType;

/**
 * Atualiza uma configuração de comissionamento existente
 *
 * @function updateCommissionConfigData
 * @param {string} id - ID do item a ser atualizado
 * @param {object} data - Novos dados do item
 * @returns {apiResponseType} Resposta da API com o item atualizado
 */
export const updateCommissionConfigData = (id: string, data: any) =>
  apiAuth.put(`commissions/config/${id}/update`, data) as apiResponseType;

/**
 * Busca detalhes de uma configuração específica
 *
 * @function getShowCommissionConfig
 * @param {string} id - ID do item a ser exibido
 * @returns {apiResponseType} Resposta da API com detalhes do item
 */
export const getShowCommissionConfig = (id: string) =>
  apiAuth.get(`commissions/config/${id}/show`) as apiResponseType;

/**
 * Busca dados com filtro por nome
 *
 * @function searchCommissionConfigData
 * @param {object} params - Parâmetros de busca
 * @param {string} params.name - Nome a ser buscado
 * @returns {apiResponseType} Resposta da API com resultados filtrados
 */
export const searchCommissionConfigData = (params: {
  name: string;
}): apiResponseType => apiAuth.get(`commissions/config?name=${params.name}`);

/**
 * Alterna o status de ativo/inativo de uma configuração
 *
 * @function setStatusCommissionConfig
 * @param {string} id - ID do item a ter status alterado
 * @returns {apiResponseType} Resposta da API confirmando a alteração
 */
export const setStatusCommissionConfig = (id: string) =>
  apiAuth.put(`commissions/config/${id}/toggle-status`) as apiResponseType;

/**
 * Busca tipos de comissão para select
 *
 * @function getCommissionTypes
 * @returns {apiResponseType} Resposta da API com opções para select
 */
export const getCommissionTypes = () =>
  apiAuth.get("commissions/types") as apiResponseType;

export const getComissionSelectConfig = () =>
  apiAuth.get("commissions/config/select") as apiResponseType;

export const getAccompanimentCommissionData = (
  uuidCommission: string,
  start_date?: string,
  end_date?: string
) =>
  apiAuth.get(
    `commissions/sellers/${uuidCommission}/accompaniment?start_date=${
      start_date || ""
    }&end_date=${end_date || ""}`
  ) as apiResponseType;
